import React from "react";
import cn from "classnames";
import TulufaliLogo from "../Icons/tulufali_logo.png";
import s from "./BrandedRouteLoading.module.scss";

/**
 * @param {'content' | 'gate'} variant
 *   content — overlay di dalam main (position absolute)
 *   gate — overlay saat validasi token, tidak menutup sidebar (fixed, left: lebar sidebar)
 */
export default function BrandedRouteLoading({ variant = "content" }) {
  return (
    <div
      className={cn(s.root, {
        [s.variantContent]: variant === "content",
        [s.variantGate]: variant === "gate",
      })}
      role="status"
      aria-live="polite"
      aria-label="Memuat halaman"
    >
      <div className={s.brand}>
        <img src={TulufaliLogo} alt="Tulu Fali" />
        <div className={s.brandText}>
          <span className={s.title}>
            Tulu Fali <span className={s.version}>2.0</span>
          </span>
          <span className={s.subtitle}>
            Terintegrasi <span className={s.subtitleBadge}>Esa Office</span>
          </span>
        </div>
      </div>
      <div className="spinner-border text-primary" />
      <span className={s.hint}>Memuat halaman…</span>
    </div>
  );
}
